import React, { useEffect, useState } from 'react';
import axios from 'axios';
import IntranetLayout from './IntranetLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Plus, Pencil, Trash2, X, Bot } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IntranetRobots = () => {
  const [robots, setRobots] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ name: '', description: '' });
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const isAdmin = user.role === 'admin';
  const authHeaders = { Authorization: `Bearer ${localStorage.getItem('token')}` };

  const fetchRobots = () => axios.get(`${API}/intranet/robots`).then(r => setRobots(r.data)).catch(console.error);
  useEffect(() => { fetchRobots(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API}/intranet/robots/${editingId}`, form, { headers: authHeaders });
        toast.success('Robot modifié');
      } else {
        await axios.post(`${API}/intranet/robots`, form, { headers: authHeaders });
        toast.success('Robot ajouté');
      }
      setShowForm(false); setEditingId(null); setForm({ name: '', description: '' }); fetchRobots();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
  };

  const handleEdit = (r) => { setForm({ name: r.name, description: r.description }); setEditingId(r.id); setShowForm(true); };
  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce robot ?')) return;
    try {
      await axios.delete(`${API}/intranet/robots/${id}`, { headers: authHeaders });
      toast.success('Supprimé'); fetchRobots();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
  };

  return (
    <IntranetLayout>
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Robots</h2>
            <p className="text-sm text-slate-500">{robots.length} robots enregistrés</p>
          </div>
          {isAdmin && <Button onClick={() => { setShowForm(true); setEditingId(null); setForm({ name: '', description: '' }); }} className="btn-primary" data-testid="add-robot-btn">
            <Plus size={16} className="mr-1" /> Ajouter un robot
          </Button>}
        </div>

        {showForm && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setShowForm(false)}>
            <div className="bg-white rounded-2xl p-6 w-full max-w-sm" onClick={e => e.stopPropagation()}>
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-heading text-lg font-extrabold">{editingId ? 'Modifier' : 'Ajouter'} un robot</h3>
                <button onClick={() => setShowForm(false)}><X size={20} /></button>
              </div>
              <form onSubmit={handleSubmit} className="space-y-3" data-testid="robot-form">
                <div><Label className="text-xs font-semibold mb-1 block">Nom *</Label><Input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="rounded-lg" data-testid="input-robot-name" /></div>
                <div><Label className="text-xs font-semibold mb-1 block">Description</Label><Input value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="rounded-lg" /></div>
                <Button type="submit" className="w-full btn-primary justify-center" data-testid="submit-robot">{editingId ? 'Enregistrer' : 'Ajouter'}</Button>
              </form>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {robots.map(r => (
            <div key={r.id} className="bg-white rounded-xl border border-slate-200 p-5 flex items-start gap-3" data-testid={`robot-${r.id}`}>
              <div className="w-10 h-10 bg-[#F97316]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Bot size={20} className="text-[#F97316]" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-900 text-sm truncate">{r.name}</p>
                <p className="text-xs text-slate-500">{r.description || 'Aucune description'}</p>
              </div>
              {isAdmin && <div className="flex gap-1 flex-shrink-0">
                <button onClick={() => handleEdit(r)} className="text-[#1B6FE3] hover:bg-blue-50 p-1.5 rounded-lg"><Pencil size={14} /></button>
                <button onClick={() => handleDelete(r.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded-lg"><Trash2 size={14} /></button>
              </div>}
            </div>
          ))}
        </div>
      </div>
    </IntranetLayout>
  );
};

export default IntranetRobots;
